<template>
  <div class="chat-container">
    <!-- 顶部导航栏 -->
    <!-- <div class="nav-bar">
      <div class="left">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="title">
        <img
          class="avatar"
          src="@/assets/logo.png"
        />
        叮小咚
      </div>
      <div class="right">
        <el-badge
          :value="14"
          class="cart-badge"
        >
          <i class="el-icon-shopping-cart-2"></i>
        </el-badge>
        <i class="el-icon-more"></i>
      </div>
    </div> -->

    <!-- 聊天区域 -->
    <div
      class="chat-messages"
      ref="messageBox"
    >
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        success-text="刷新成功"
      >
        <van-list
          v-model="historyLoading"
          :finished="!hasMoreHistory"
          finished-text="没有更多了"
          :immediate-check="false"
          direction="up"
          @load="loadHistoryMessages"
        >
          <!-- AI欢迎语 -->
          <div class="message ai">
            <img
              class="avatar"
              src="@/assets/logo.png"
            />
            <div
              class="bubble"
              v-html="convertMarkdownToHtml('您好,我是叮小咚,我们有丰富的蔬菜和豆制品供您选择。您想了解哪些特色菜品呢?')"
            ></div>
          </div>

          <!-- 快捷问题选项 -->
          <div class="quick-questions">
            <div class="questions-wrapper">
              <div
                class="question"
                v-for="(q, i) in currentQuestions"
                :key="i"
                @click="sendQuestion(q)"
              >
                {{ q }}
              </div>
            </div>
            <div
              class="refresh-btn"
              @click="refreshQuestions"
            >
              <i class="el-icon-refresh"></i>
              换一批
            </div>
          </div>

          <!-- 聊天记录 -->
          <div
            v-for="(msg, index) in messages"
            :key="index"
            :class="['message', msg.type]"
          >
            <template v-if="msg.type === 'user'">
              <img
                class="avatar"
                src="@/assets/images/aichat/user.png"
              />
              <div class="bubble">{{ msg.content }}</div>
            </template>
            <template v-else>
              <img
                class="avatar"
                src="@/assets/images/aichat/system.png"
              />
              <div class="bubble">
                <div v-html="convertMarkdownToHtml(msg.content)"></div>
                <div class="ai-footer">
                  <span>AI生成仅供参考</span>
                  <div class="actions">
                    <i
                      class="el-icon-document-copy copy-icon"
                      @click="copyMessage(msg.content)"
                      title="复制内容"
                    ></i>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- 底部输入区 -->
    <div class="chat-input">
      <div class="input-box">
        <i class="el-icon-chat-round"></i>
        <textarea
          v-model="inputMessage"
          placeholder="可以问我问题哦~"
          @keyup.enter.exact="sendMessage"
          @keyup.ctrl.enter="inputMessage += '\n'"
          @input="adjustHeight"
          ref="inputArea"
        ></textarea>
        <div
          class="send-btn"
          :class="{ active: inputMessage.trim() }"
          @click="sendMessage"
        >
          <i class="el-icon-s-promotion"></i>
        </div>
      </div>
      <div class="nav-buttons">
        <div class="nav-btn"></div>
        <div class="nav-btn circle"></div>
        <div class="nav-btn"></div>
      </div>
    </div>
  </div>
</template>

<script>
import getUserInfo from "@/models/userInfo";
import { List, PullRefresh, Toast } from "vant";

export default {
  name: "AiChat",
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      inputMessage: "",
      messages: [],
      isRequestInProgress: false,
      currentUserInfo: {},
      // 历史消息相关参数
      historyLoading: false,
      hasMoreHistory: true,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      refreshing: false,
      // 所有可用的问题列表
      allQuestions: [
        "蔬菜和豆制品如何搭配最健康?",
        "有哪些适合日常食用的特色菜品?",
        "这些食材适合哪些烹饪方式?",
        "如何选择新鲜的蔬菜?",
        "豆制品的营养价值有哪些?",
        "有什么适合减脂的菜品推荐?",
        "如何做到均衡搭配?",
        "有什么快手菜的推荐?",
        "适合老人吃的菜品有哪些?",
      ],
      // 当前显示的问题
      currentQuestions: [],
      // 自动滚动控制
      shouldAutoScroll: true,
      userHasScrolled: false,
    };
  },
  async created() {
    this.refreshQuestions();
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    // 加载历史消息
    await this.loadHistoryMessages();

    // 确保首次加载后滚动到底部
    this.$nextTick(() => {
      this.scrollToBottom();
    });
  },
  mounted() {
    // 添加滚动事件监听
    this.$refs.messageBox.addEventListener("scroll", this.handleUserScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    this.$refs.messageBox.removeEventListener("scroll", this.handleUserScroll);
  },
  methods: {
    // 用户手动滚动处理
    handleUserScroll() {
      if (!this.isRequestInProgress) return;

      const messageBox = this.$refs.messageBox;
      const isScrolledToBottom =
        messageBox.scrollHeight - messageBox.scrollTop <=
        messageBox.clientHeight + 50;

      if (!isScrolledToBottom && !this.userHasScrolled) {
        // 用户向上滚动，中止自动滚动
        this.userHasScrolled = true;
        this.shouldAutoScroll = false;
      }
    },

    // 滚动到底部
    scrollToBottom() {
      if (!this.shouldAutoScroll) return;

      this.$nextTick(() => {
        const messageBox = this.$refs.messageBox;
        messageBox.scrollTop = messageBox.scrollHeight;
      });
    },
    // 下拉刷新
    async onRefresh() {
      try {
        // 重置分页参数
        this.pageIndex = 1;
        this.hasMoreHistory = true;
        this.messages = [];
        // 重新加载消息
        await this.loadHistoryMessages();
        this.refreshing = false;
      } catch (error) {
        console.error("刷新失败:", error);
        this.refreshing = false;
      }
    },

    // 加载历史消息
    async loadHistoryMessages() {
      if (!this.hasMoreHistory) {
        this.historyLoading = false;
        return;
      }

      this.historyLoading = true;

      try {
        // 保存当前滚动位置
        const messageBox = this.$refs.messageBox;
        const oldHeight = messageBox.scrollHeight;

        const response = await fetch(
          `${process.env.VUE_APP_AI_CHAT_URL}/api/aidoctoragentsk/record-list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              user_id: this.currentUserInfo.user_id || "",
              user_type: "ykyjlr_v2",
              page_index: this.pageIndex,
              page_size: this.pageSize,
              order_by_descending: 1,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("获取历史消息失败");
        }

        const result = await response.json();

        if (result.Status !== 200) {
          throw new Error(result.Message || "获取历史消息失败");
        }

        const data = result.Data;

        // 更新分页参数
        this.totalPage = data.total_page;
        this.hasMoreHistory = this.pageIndex < this.totalPage;

        // 处理并添加消息到列表
        if (data.records && data.records.length > 0) {
          const historyMessages = data.records.map((record) => ({
            type: record.msg_role === "user" ? "user" : "ai",
            content: record.msg_data,
            timestamp: new Date(record.create_time),
            id: record.id,
          }));

          // 按时间顺序添加消息
          if (this.pageIndex === 1) {
            // 第一页消息添加到末尾
            this.messages = [...this.messages, ...historyMessages.reverse()];
          } else {
            // 第二页及之后的消息添加到头部
            this.messages = [...historyMessages.reverse(), ...this.messages];
          }

          // 如果是第一次加载，加载完成后滚动到底部
          if (this.pageIndex === 1) {
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          } else {
            // 保持滚动位置
            this.$nextTick(() => {
              const newHeight = messageBox.scrollHeight;
              messageBox.scrollTop = newHeight - oldHeight;
            });
          }
        }

        // 更新页码，为下一次加载做准备
        this.pageIndex += 1;
      } catch (error) {
        console.error("加载历史消息失败:", error);
      } finally {
        // 无论成功失败，都需要设置loading状态为false
        this.historyLoading = false;
      }
    },
    sendQuestion(question) {
      this.inputMessage = question;
      this.sendMessage();
      // 重置输入框高度
      this.$refs.inputArea.style.height = "20px";
    },
    async sendMessage() {
      if (!this.inputMessage.trim() || this.isRequestInProgress) return;

      this.isRequestInProgress = true;
      // 重置滚动控制
      this.shouldAutoScroll = true;
      this.userHasScrolled = false;

      // 添加用户消息
      this.messages.push({
        type: "user",
        content: this.inputMessage,
      });

      // 滚动到底部显示用户消息
      this.scrollToBottom();

      const userMessage = this.inputMessage;
      this.inputMessage = "";
      // 重置输入框高度
      this.$refs.inputArea.style.height = "20px";

      try {
        // 调用AI接口
        const response = await fetch(
          `${process.env.VUE_APP_AI_CHAT_URL}/api/aidoctoragentsk/completions`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify({
              user_id: this.currentUserInfo.user_id || "string",
              user_type: "ykyjlr_v2",
              user_name: this.currentUserInfo.user_name || "string",
              msg_type: 0,
              msg_data: userMessage,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("网络请求失败");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let currentMessage = { type: "ai", content: "" };
        this.messages.push(currentMessage);

        // 滚动到底部显示AI开始回复
        this.scrollToBottom();

        // 添加超时处理，防止无限等待
        let responseTimeout = false;
        const timeoutId = setTimeout(() => {
          responseTimeout = true;
          this.isRequestInProgress = false;
          console.warn("AI响应超时");
        }, 30000); // 30秒超时

        try {
          // eslint-disable-next-line no-constant-condition
          while (true) {
            if (responseTimeout) break;

            const { done, value } = await reader.read();
            if (done) {
              clearTimeout(timeoutId);
              this.isRequestInProgress = false;
              break;
            }

            // 将Uint8Array转换为字符串
            const text = decoder.decode(value, { stream: true });
            const lines = text.split("\n");

            lines.forEach((line) => {
              if (line.startsWith("data:")) {
                const jsonString = line.replace("data: ", "").trim();
                if (jsonString) {
                  try {
                    // 检查是否是有效的 JSON 字符串
                    if (
                      jsonString === "[DONE]" ||
                      jsonString === "message_end"
                    ) {
                      clearTimeout(timeoutId);
                      this.isRequestInProgress = false;
                      return;
                    }

                    const json = JSON.parse(jsonString);
                    if (
                      json.event === "agent_message" &&
                      json.data &&
                      json.data.Content !== null
                    ) {
                      currentMessage.content += json.data.Content;
                      // 在消息更新时滚动到底部
                      this.scrollToBottom();
                    }
                  } catch (e) {
                    console.error("JSON解析错误:", e, "原始数据:", jsonString);
                    // 如果解析失败，尝试直接添加内容
                    if (jsonString.includes("Content")) {
                      try {
                        const contentMatch =
                          jsonString.match(/"Content":"([^"]+)"/);
                        if (contentMatch && contentMatch[1]) {
                          currentMessage.content += contentMatch[1];
                          this.scrollToBottom();
                        }
                      } catch (innerError) {
                        console.error("内容提取失败:", innerError);
                      }
                    }
                  }
                }
              }
            });
          }
        } finally {
          // 确保清除超时计时器
          clearTimeout(timeoutId);
          // 无论读取流过程如何结束，都确保重置状态
          this.isRequestInProgress = false;
        }
      } catch (error) {
        console.error("AI响应错误:", error);
        this.messages.push({
          type: "ai",
          content: "抱歉，我现在无法回答您的问题，请稍后再试。",
        });
        this.isRequestInProgress = false;
        // 显示错误消息时滚动到底部
        this.scrollToBottom();
      } finally {
        // 确保请求完成后重置状态
        this.isRequestInProgress = false;
        this.shouldAutoScroll = true;
        this.scrollToBottom();
      }
    },
    // 刷新显示的问题
    refreshQuestions() {
      // 随机选择3个问题显示
      const questions = [...this.allQuestions];
      this.currentQuestions = [];

      for (let i = 0; i < 3 && questions.length > 0; i++) {
        const randomIndex = Math.floor(Math.random() * questions.length);
        this.currentQuestions.push(questions[randomIndex]);
        questions.splice(randomIndex, 1);
      }
    },
    // 复制消息内容到剪贴板
    copyMessage(content) {
      // navigator.clipboard.writeText(content);
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        Toast("复制成功");
        return navigator.clipboard.writeText(content);
      } else {
        // 创建text area
        const textArea = document.createElement("textarea");
        textArea.value = content;
        // 使text area不在viewport，同时设置不可见
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        Toast("复制成功");
        return new Promise((res, rej) => {
          // 执行复制命令并移除文本框
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    // 调整输入框高度
    adjustHeight() {
      const textarea = this.$refs.inputArea;
      textarea.style.height = "auto";
      textarea.style.height = Math.min(textarea.scrollHeight, 100) + "px";
    },
    // 添加 Markdown 转换方法
    convertMarkdownToHtml(markdown) {
      try {
        // 简单的 Markdown 转换实现
        if (!markdown) return "";

        let html = markdown;

        // 首先处理 \n 字符串为实际的换行符
        html = html.replace(/\\n/g, "\n");

        // 处理标题（需要在处理换行之前）
        html = html.replace(/^###\s+(.*?)$/gm, "<h3>$1</h3>");
        html = html.replace(/^##\s+(.*?)$/gm, "<h2>$1</h2>");
        html = html.replace(/^#\s+(.*?)$/gm, "<h1>$1</h1>");

        // 处理列表项（需要在处理换行之前）
        html = html.replace(/^\s*-\s+(.*?)$/gm, "<li>$1</li>");
        html = html.replace(/(<li>.*<\/li>)/s, "<ul>$1</ul>");

        // 处理加粗（需要在处理换行之前）
        html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

        // 处理斜体
        html = html.replace(/\*(.*?)\*/g, "<em>$1</em>");

        // 处理链接
        html = html.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>');

        // 处理代码块
        html = html.replace(/```([\s\S]*?)```/g, "<pre><code>$1</code></pre>");

        // 处理行内代码
        html = html.replace(/`(.*?)`/g, "<code>$1</code>");

        // 最后处理换行
        html = html.replace(/\n/g, "<br>");

        return html;
      } catch (error) {
        console.error("Markdown 转换错误:", error);
        return markdown;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-container {
  height: 100vh;
  background: #fff5f5;
  display: flex;
  flex-direction: column;
}

.nav-bar {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;

  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;

    .avatar {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-right: 8px;
    }
  }

  .right {
    display: flex;
    align-items: center;
    gap: 15px;
  }
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  background: #fff5f5;

  :deep(.van-list) {
    min-height: 100%;
    padding: 15px;
  }

  :deep(.van-pull-refresh) {
    overflow-y: auto;
  }

  .message {
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;

    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .bubble {
      max-width: 70%;
      padding: 12px;
      border-radius: 8px;
      background: #fff;
      font-size: 14px;
      line-height: 1.5;
      user-select: text; /* 添加此行确保文本可选 */

      :deep(p) {
        margin: 0 0 10px 0;
        &:last-child {
          margin-bottom: 0;
        }
      }

      :deep(code) {
        background-color: #f5f5f5;
        padding: 2px 4px;
        border-radius: 4px;
        font-family: monospace;
      }

      :deep(pre) {
        background-color: #f5f5f5;
        padding: 10px;
        border-radius: 4px;
        overflow-x: auto;
        margin: 10px 0;

        code {
          background-color: transparent;
          padding: 0;
        }
      }

      :deep(ul),
      :deep(ol) {
        padding-left: 20px;
        margin: 10px 0;
      }

      :deep(a) {
        color: #e7635e;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }

      :deep(blockquote) {
        border-left: 4px solid #e7635e;
        margin: 10px 0;
        padding-left: 10px;
        color: #666;
      }
    }

    &.user {
      flex-direction: row-reverse;

      .bubble {
        background: #e7635e;
        color: #fff;
        user-select: text; /* 确保用户消息也可选 */
      }
    }

    .ai-footer {
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px solid #eee;
      color: #999;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .actions {
        display: flex;
        gap: 15px;

        .copy-icon {
          cursor: pointer;
          &:hover {
            color: #e7635e;
          }
        }
      }
    }
  }
}

.quick-questions {
  margin: 15px 0;

  .questions-wrapper {
    margin-bottom: 10px;
  }

  .question {
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 20px;
    border: 1px solid #e7635e;
    color: #e7635e;
    font-size: 14px;
    text-align: left;
    cursor: pointer;

    &:hover {
      background: rgba(231, 99, 94, 0.1);
    }
  }

  .refresh-btn {
    display: flex;
    align-items: center;
    justify-content: start;
    color: #999;
    font-size: 14px;
    cursor: pointer;

    i {
      margin-right: 5px;
      font-size: 16px;
    }

    &:hover {
      color: #e7635e;
    }

    &:active i {
      animation: rotate 0.3s linear;
    }
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.chat-input {
  padding: 15px;
  background: #fff;

  .input-box {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background: #f7f7f7;
    border-radius: 20px;

    i {
      color: #999;
      margin-right: 10px;
      font-size: 20px;
    }

    textarea {
      flex: 1;
      border: none;
      background: none;
      outline: none;
      font-size: 14px;
      resize: none;
      max-height: 100px;
      min-height: 20px;
      line-height: 1.5;
      padding: 0;
      margin: 0;
      overflow-y: auto;
      height: 20px;
      transition: height 0.1s ease;

      &::placeholder {
        color: #999;
      }
    }

    .send-btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      background: #ddd;
      cursor: not-allowed;
      transition: all 0.3s;

      i {
        margin: 0;
        color: #fff;
        font-size: 18px;
      }

      &.active {
        background: #e7635e;
        cursor: pointer;

        &:hover {
          background: darken(#e7635e, 5%);
        }
      }
    }
  }

  .nav-buttons {
    margin-top: 15px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .nav-btn {
      width: 20px;
      height: 3px;
      background: #ddd;
      border-radius: 2px;

      &.circle {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #f7f7f7;
      }
    }
  }
}
</style>
